export let legacy_mode_flag = false;

export function enable_legacy_mode_flag() {
	legacy_mode_flag = true;
}
